<div class="see-credits-container">
  <h2>Utilisation des Licences</h2>

  <!-- Filtres de dates -->
  <form [formGroup]="dateRangeForm" class="date-filter-form">
    <mat-form-field appearance="outline">
      <mat-label>Date de début</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        formControlName="startDate"
        (dateChange)="onDateChange()"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="startPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Date de fin</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        formControlName="endDate"
        (dateChange)="onDateChange()"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="endPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <button
      type="button"
      mat-raised-button
      color="primary"
      (click)="exportToExcel()"
      [disabled]="(loading$ | async) || institutionsData.data.length === 0"
    >
      <mat-icon>get_app</mat-icon>
      Exporter vers Excel
    </button>
  </form>

  <!-- Message d'erreur -->
  <div *ngIf="error$ | async as error" class="error-message">
    <mat-icon>error</mat-icon>
    {{ error }}
  </div>

  <!-- Indicateur de chargement -->
  <div *ngIf="loading$ | async" class="loading-indicator">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Chargement des données...</p>
  </div>

  <!-- Tableau des données -->
  <div
    *ngIf="!(loading$ | async) && !(error$ | async)"
    class="data-table-container"
  >
    <table
      mat-table
      [dataSource]="institutionsData"
      class="institutions-table"
      matSort
      multiTemplateDataRows
    >
      <!-- Colonne Nom de l'institution -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Institution</th>
        <td mat-cell *matCellDef="let institution">{{ institution.name }}</td>
      </ng-container>

      <!-- Colonne Institution Parente -->
      <ng-container matColumnDef="parentInstitution">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Institution Parente
        </th>
        <td mat-cell *matCellDef="let institution">
          {{ institution.parentInstitution || '-' }}
        </td>
      </ng-container>

      <!-- Colonne Total Inscriptions -->
      <ng-container matColumnDef="totalRegistrations">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Total Inscriptions
        </th>
        <td mat-cell *matCellDef="let institution">
          <span class="registration-count">{{
            institution.totalRegistrations
          }}</span>
        </td>
      </ng-container>

      <!-- Colonne Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td
          mat-cell
          *matCellDef="let institution"
          (click)="$event.stopPropagation()"
        >
          <button
            mat-icon-button
            (click)="exportInstitutionToExcel(institution)"
            *ngIf="institution.totalRegistrations > 0"
            matTooltip="Télécharger Excel"
          >
            <mat-icon>get_app</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Ligne de détails extensible -->
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let institution"
          [attr.colspan]="displayedColumns.length"
        >
          <div
            class="institution-detail"
            [@detailExpand]="
              institution === expandedInstitution ? 'expanded' : 'collapsed'
            "
          >
            <div class="detail-header">
              <h3>Détails des inscriptions pour {{ institution.name }}</h3>
            </div>

            <table class="registrations-table">
              <thead>
                <tr>
                  <th>Établissement</th>
                  <th>Établissement Parent</th>
                  <th>Niveau</th>
                  <th>Date de création</th>
                  <th>Email</th>
                  <th>Créateur</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let reg of institution.registrations">
                  <td>{{ reg.institutionName }}</td>
                  <td>
                    {{
                      reg.institutionName === institution.name
                        ? ''
                        : institution.name
                    }}
                  </td>
                  <td>{{ reg.level }}</td>
                  <td>{{ reg.created_at | date: 'short' }}</td>
                  <td>{{ reg.email }}</td>
                  <td>{{ reg.creatorEmail }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.expanded-row]="expandedInstitution === row"
        (click)="toggleDetails(row)"
        class="clickable-row"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="detail-row"
      ></tr>
    </table>

    <!-- Message si aucune donnée -->
    <div *ngIf="institutionsData.data.length === 0" class="no-data">
      <mat-icon>inbox</mat-icon>
      <p>Aucune inscription trouvée pour la période sélectionnée</p>
    </div>
  </div>
</div>
